import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';


@Component({
})
export default class SBCheckbox extends Mixins(SBComponentVue) {

    @Prop({
        type: Boolean,
        default: false,
    })
    public disable!: boolean;

    @Prop({
        type: Boolean,
        default: false,
    })
    public value!: boolean;

    public localValue: boolean = false;

    @Emit("input")
    public input(val: boolean) {
    }

    @Prop({
        type: String,
        required: false,
    })
    public label!: string;

    public created() {
        this.localValue = this.value;
    }

    public boxClick() {
        if (this.disable) return;
        this.localValue = !this.localValue;
        this.$emit("input", this.localValue);
    }

}
